<div class="dialog-container">
  <app-mat-spinner-overlay [overlay]="true" *ngIf="loading">
  </app-mat-spinner-overlay>
  <div class="dialog-header">
    <h2 mat-dialog-title>Novo AEP - Acordo Especial de Preço</h2>
    <button mat-icon-button [mat-dialog-close]="null" class="close-button" matTooltip="Fechar diálogo">
      <mat-icon matTooltip="Fechar diálogo">close</mat-icon>
    </button>
  </div>
  <div class="dialog-content">
    <app-acordos-existentes *ngIf="acordosExistentes.length" [combustiveis]="combustiveis"
      [acordosExistentes]="acordosExistentes" [msgAcordosExistentes]="msgAcordosExistentes">
    </app-acordos-existentes>

    <!-- {{ acordosForm.value | json }} -->
    <div class="container-flex" [formGroup]="acordosForm">
      <div class="row">
        <div class="col">
          <!--          <label class="form-label">Frota</label>-->
          <div class="d-md-flex justify-content-md-start">
            <mat-form-field class="w-100">
              <mat-label>Selecionar Frota</mat-label>
              <input matInput
              formControlName="buscaFrota"
              (focusout)="verificarCliqueLupa()"

              autocomplete="off"
                placeholder="Ex. Ctf frota #" />
              <mat-error>
                <span class="error-text">Clique na lupa para buscar e selecionar uma frota!</span>
              </mat-error>

              <button mat-icon-button matSuffix (click)="openDialog()">
                <mat-icon>search</mat-icon>
              </button>
              <button mat-icon-button matSuffix (click)="limparDadosFrota()">
                <mat-icon>delete</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <table class="table table-sm table-bordered table-striped" *ngIf="frotaSelecionada">
            <thead>
              <tr class="table-header">
                <th>Cód. da frota</th>
                <th>Nome Fantasia</th>
                <th>Cidade</th>
                <th>UF</th>
              </tr>
            </thead>
            <tbody>
              <tr class="table-row">
                <td>{{ frotaSelecionada.codigo }}</td>
                <td>{{ frotaSelecionada.nomeReduzido }}</td>
                <td>{{ frotaSelecionada.municipio }}</td>
                <td>{{ frotaSelecionada.estado }}</td>
              </tr>
            </tbody>
          </table>
          <div>
            <div class="d-md-flex justify-content-md-start">
              <mat-form-field class="w-100">
                <mat-label>Tipo</mat-label>
                <mat-select formControlName="tipo" (selectionChange)="onTipoChange($event)">
                  <mat-option selected="selected" value="">Selecione</mat-option>
                  <mat-option value=2>Acordo de Preço Fixo</mat-option>
                  <mat-option value=5>Acordo desconto em R$/litro</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="d-md-flex justify-content-md-start" *ngIf="acordosForm.get('tipo')?.value === '2'">
              <mat-form-field class="w-100">
                <mat-label>Valor Fixo</mat-label>
                <input matInput formControlName="valorFixo" autocomplete="off" type="text" currencyMask [options]="{
                  prefix: 'R$ ',
                  thousands: '.',
                  decimal: ',',
                  allowNegative: false
                }" />
              </mat-form-field>
            </div>
            <div class="d-md-flex justify-content-md-start" *ngIf="acordosForm.get('tipo')?.value === '5'">
              <mat-form-field class="w-100">
                <mat-label>Valor do Desconto</mat-label>
                <input matInput formControlName="valorDescontoEmReais" autocomplete="off" type="text" currencyMask
                  [options]="{
                  prefix: 'R$ ',
                  thousands: '.',
                  decimal: ',',
                  allowNegative: false
                }" />
              </mat-form-field>
            </div>


            <div class="d-md-flex justify-content-md-start">
              <mat-form-field class="w-100">
                <mat-label>Combustível</mat-label>
                <mat-select formControlName="combustivel">
                  <mat-option selected="selected">Selecione</mat-option>
                  <mat-option *ngFor="let combustivel of combustiveis;" [value]="combustivel.codigoCombustivel">
                    {{ combustivel.combustivel }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-end">
          <button mat-button class="btn-acao" (click)="onCancelar()">Voltar</button>
          <button mat-raised-button class="btn-acao " [ngClass]="isFormValid() ? 'btn-confirmar': '' "
            [disabled]="acordosForm.invalid || loading || !isFormValid()" (click)="onConfirmar()">
            Criar Acordo
          </button>
        </div>
      </div>
    </div>
  </div>
</div>